module.exports = __webpack_public_path__ + "685ab2db77cf1cf368e58be90cde275e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/around/palm-tree.png
// module id = 1159
// module chunks = 0